import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";

// ----------------------------------------------------------------------------
// Department code -> plain label. ONE shared resolver for every surface (reports,
// 360 invoice badges, tech payroll). AUTHORITATIVE: mirror_department, mirrored
// from ESC's SlDept table (sync-departments.ps1). useDepartments() loads the live
// names into DEPT_DB and wins over the hardcoded fallback; the fallback is the
// SAME data (verified against mirror_department 2026-06-17) for the first render
// before the fetch resolves / if the mirror is ever empty.
//
// The earlier per-file guesses were materially wrong (02 "Sales" -> New
// Construction, 04 "Maintenance" -> Counter Sales, 06 "Duct Cleaning" ->
// Commercial Service, 09 "Other" -> Commercial Plumbing). Never re-hardcode a
// dept label in a component again — import deptLabel from here.
// ----------------------------------------------------------------------------
export const DEPT_LABEL: Record<string, string> = {
  "01": "Install / Sales", "02": "New Construction", "03": "Service", "04": "Counter Sales",
  "05": "Service Contracts", "06": "Commercial Service", "07": "Commercial Install",
  "08": "Plumbing", "09": "Commercial Plumbing",
};

let DEPT_DB: Record<string, string> = {};

export function useDepartments() {
  return useQuery({
    queryKey: ["mirror_department"],
    staleTime: 60 * 60 * 1000,
    queryFn: async () => {
      const { data } = await supabase.from("mirror_department").select("dept_code, dept_name");
      const next: Record<string, string> = {};
      for (const r of (data ?? []) as { dept_code: string | null; dept_name: string | null }[]) {
        const c = (r.dept_code ?? "").trim();
        if (c && r.dept_name) next[c] = r.dept_name;
      }
      DEPT_DB = next;
      return next;
    },
  });
}

export function deptLabel(code: string | null): string {
  const c = (code ?? "").trim();
  return DEPT_DB[c] ?? DEPT_LABEL[c] ?? (c ? `Dept ${c}` : "Unassigned");
}
